// library imports
import { Tag, Tooltip, Flex } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useContext } from "react";
// style imports
import "../../styles/Dashboard/SummaryCard.css";
// config imports
import {
  DARK_BLUE,
  DARK_GREEN,
  DARK_THEME_DARK_BLUE,
  PURPLE,
} from "../../configs/configs";
// context imports
import { IndexContext } from "../../context/IndexContext";

export default function _SingleContentMd({
  title = "-",
  total = "-",
  var1label = "-",
  var2label = "-",
  var1value = "-",
  var2value = "-",
  unit = "-",
  loadMDDateTime = "-",
  tnbMDDateTime = "-",
}) {
  const { isLightTheme } = useContext(IndexContext);

  let percentage1 = "-";
  let percentage2 = "-";

  if (total !== "-") {
    if (var1value !== "-") {
      percentage1 = 100 * (var1value / total);
    }
    if (var2value !== "-") {
      percentage2 = 100 * (var2value / total);
    }
  }

  return (
    <div className="summary-content-content-container">
      <span>
        {title}:
        <span className="summary-content-value">
          {total !== "-"
            ? `${parseFloat(total).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ${unit}`
            : `${total}`}{" "}
          <Tooltip
            title={
              "Before reduction by AIE-DR, maximum demand occurs on: " +
              loadMDDateTime
            }
          >
            <InfoCircleOutlined />
          </Tooltip>
        </span>
      </span>

      {percentage1 !== "-" && percentage2 !== "-" ? (
        <Flex vertical={false} align="center" justify="center" className="mb-1">
          <div
            style={{
              height: "20px",
              backgroundColor: DARK_GREEN,
              flex: percentage1,
              borderRadius: "15px",
              marginRight: "-15px",
              zIndex: 1,
            }}
          />
          <div
            style={{
              height: "20px",
              backgroundColor:
                var2label === "Genset Supplied"
                  ? PURPLE
                  : isLightTheme
                  ? DARK_BLUE
                  : DARK_THEME_DARK_BLUE,
              flex: percentage2,
              borderTopRightRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          />
        </Flex>
      ) : null}

      {/* var 1 */}
      <div className="summary-content-detail">
        <Tag color={DARK_GREEN}></Tag>

        <span>{var1label}:</span>

        <span className="summary-content-percentage">
          {var1value !== "-"
            ? `${parseFloat(var1value).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ${unit}`
            : `${var1value}`}
        </span>
      </div>

      {/* var 2 */}
      <div className="summary-content-detail">
        <Tag
          color={
            var2label === "Genset Supplied"
              ? PURPLE
              : isLightTheme
              ? DARK_BLUE
              : DARK_THEME_DARK_BLUE
          }
        ></Tag>

        <span>{var2label}:</span>

        <span className="summary-content-percentage">
          {var2value !== "-" ? (
            <>
              {parseFloat(var2value).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              {unit}{" "}
              <Tooltip
                title={
                  "After reduction by AIE-DR, maximum demand occurs on: " +
                  tnbMDDateTime
                }
              >
                <InfoCircleOutlined />
              </Tooltip>
            </>
          ) : (
            `${var2value}`
          )}
        </span>
      </div>
    </div>
  );
}
